import React from 'react';
import { painPoints } from '../data/painPoints';
export function PainSection() {
  return <section className="bg-navy py-5 sm:py-7" data-id="element-142" data-mp="38yggibtmasnx">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-143" data-mp="38x5cqc069kwt">
        <h2 className="text-center text-2xl leading-tight text-white sm:text-4xl" data-id="element-144" data-mp="2uyoxfwo8um32">
          DOES THIS SOUND <span className="text-tech-light" data-id="element-145" data-mp="2yz7lrgqxha0i">FAMILIAR?</span>
        </h2>
        <p className="mx-auto mt-2 max-w-3xl text-center text-sm leading-snug text-white/85 sm:text-base" data-id="element-146" data-mp="2l8cbq14p0mvc">
          You're assessing patients, monitoring vital signs, reviewing clinical procedures,
          managing IV devices, checking medications, and documenting patient care—but your
          nursing references are scattered across textbooks, manuals, guidelines, and different
          resources.
        </p>

        <div className="mt-3 grid gap-2 md:grid-cols-2 md:gap-2.5" data-id="element-147" data-mp="228yf1bfkwy15">
          {painPoints.map(point => <article key={point.title} className="rounded-xl border-l-4 border-alert bg-navy-deep p-3 sm:p-4" data-id="element-148" data-mp="278uk7e00ivia">
              <h3 className="text-sm leading-tight text-white sm:text-base" data-id="element-149" data-mp="3rp3qonrpnlkv">{point.title}</h3>
              <p className="mt-1 text-sm leading-snug text-white/80" data-id="element-150" data-mp="3nniaasfywp5x">{point.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}